import { render, staticRenderFns } from "./ProfileSetup.vue?vue&type=template&id=aa88e2de"
import script from "./ProfileSetup.vue?vue&type=script&lang=js"
export * from "./ProfileSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports